export default __webpack_public_path__ + "b886801e56cbf50191f8ed4a31154d0f.png";